/*
 * View for an engine item
 */

define([
  "marionette",
  "modules/accountAdmin/engineAdminModal/template/engineAdminModalTemplate.html",
], function (Marionette, EngineAdminModalTemplate) {
  var EngineAdminModalView = {};

  EngineAdminModalView.engineAdminModalView = Marionette.ItemView.extend({
    template: EngineAdminModalTemplate,
    getEngineName: function () {
      return this.$el.find("#engineName").val().trim();
    },
    getEngineDescription: function () {
      return this.$el.find("#engineDescription").val().trim();
    },
    getSoapDomain: function () {
      return this.$el.find("#soapDomain").val().trim();
    },
    getKbCapacity: function () {
      return parseInt(this.$el.find("#capacity").val(), 10);
    },
    getInternalUrl: function () {
      return this.$el.find("#internalUrl").val().trim();
    },
    engineNameError: function (errorMessage) {
      this.$el
        .find("#engineNameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    engineDescriptionError: function (errorMessage) {
      this.$el
        .find("#engineDescriptionError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    soapDomainError: function (errorMessage) {
      this.$el
        .find("#soapDomainError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    capacityError: function (errorMessage) {
      this.$el
        .find("#capacityError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    internalUrlError: function (errorMessage) {
      this.$el
        .find("#internalUrlError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return EngineAdminModalView;
});
